const fallbackMeasurementId = "G-7DRZZYWZMD";
const measurementId =
  (import.meta.env.VITE_GA_MEASUREMENT_ID as string | undefined)?.trim() ||
  fallbackMeasurementId;
// Always enable GA4; still guard against missing measurement ID
export const isGa4Enabled = Boolean(measurementId);

declare global {
  interface Window {
    dataLayer: unknown[];
    gtag: (...args: unknown[]) => void;
  }
}

let initialized = false;

function injectScript(id: string) {
  if (document.getElementById("ga4-script")) return;
  const script = document.createElement("script");
  script.id = "ga4-script";
  script.async = true;
  script.src = `https://www.googletagmanager.com/gtag/js?id=${id}`;
  document.head.appendChild(script);
}

export function initGa4() {
  if (initialized || !isGa4Enabled || typeof window === "undefined") return;

  window.dataLayer = window.dataLayer || [];
  window.gtag =
    window.gtag ||
    function gtag(...args: unknown[]) {
      window.dataLayer.push(args);
    };
  injectScript(measurementId);
  window.gtag("js", new Date());
  window.gtag("config", measurementId, { send_page_view: false });
  initialized = true;
}

export function trackPageView(path: string, title?: string) {
  if (!isGa4Enabled || typeof window === "undefined") return;
  initGa4();
  window.gtag("event", "page_view", {
    page_title: title || document.title,
    page_location: window.location.href,
    page_path: path,
  });
}

type TrackEventPayload = {
  name: string;
  params?: Record<string, unknown>;
};

export function trackEvent(name: string, params?: Record<string, unknown>): void;
export function trackEvent(payload: TrackEventPayload): void;
export function trackEvent(
  nameOrPayload: string | TrackEventPayload,
  params?: Record<string, unknown>
) {
  if (!isGa4Enabled || typeof window === "undefined") return;
  initGa4();
  const { name, params: finalParams } =
    typeof nameOrPayload === "string"
      ? { name: nameOrPayload, params }
      : nameOrPayload;
  window.gtag("event", name, finalParams || {});
}

export const analyticsEvents = {
  pageView: "page_view",
  ctaClick: "cta_click",
  outboundClick: "outbound_click",
  viewPackage: "view_package",
  viewDestination: "view_destination",
  search: "search",
  selectItem: "select_item",
  generateLead: "generate_lead",
};
